import { SCHEMA_VERSION } from '../db/schema';
import { localIso } from './time';
import type { ParkingLotEntry, Ping, RescueSession } from '../types';

export function toJsonExport(allTables: Record<string, unknown[]>): string {
  return JSON.stringify(
    {
      schemaVersion: SCHEMA_VERSION,
      exportedAtMs: Date.now(),
      ...allTables
    },
    null,
    2
  );
}

function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function pingsToCsv(pings: Ping[]): string {
  const head = 'id,ts_ms,friction_started_ms,local_iso,type,subtype,interruption_source,note';
  const rows = pings.map((p) =>
    [p.id, p.ts_ms, p.friction_started_ms ?? '', localIso(p.ts_ms), p.type, p.subtype ?? '', p.interruption_source ?? '', p.note ?? '']
      .map(csvEscape)
      .join(',')
  );
  return [head, ...rows].join('\n');
}

export function rescuesToCsv(rescues: RescueSession[]): string {
  const head =
    'id,ping_id,ts_start_ms,ts_end_ms,kind,completed,prep_phone_silenced,prep_tabs_closed,prep_doc_open,prep_timer_visible,tiny_win,note';
  const rows = rescues.map((r) =>
    [
      r.id,
      r.ping_id ?? '',
      r.ts_start_ms,
      r.ts_end_ms ?? '',
      r.kind,
      r.completed,
      r.prep_phone_silenced ?? '',
      r.prep_tabs_closed ?? '',
      r.prep_doc_open ?? '',
      r.prep_timer_visible ?? '',
      r.tiny_win ?? '',
      r.note ?? ''
    ]
      .map(csvEscape)
      .join(',')
  );
  return [head, ...rows].join('\n');
}

export function parkingLotToCsv(entries: ParkingLotEntry[]): string {
  const head = 'id,ts_ms,local_iso,text,ping_id';
  const rows = entries.map((e) => [e.id, e.ts_ms, localIso(e.ts_ms), e.text, e.ping_id ?? ''].map(csvEscape).join(','));
  return [head, ...rows].join('\n');
}

export function downloadBlob(name: string, content: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
